module.exports = __webpack_public_path__ + "static/media/german_infantry_division_120.0fe634b7.png";